<template>
  <AdminLayout><ReviewOrdersTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import ReviewOrdersTable from './ReviewOrdersTable.vue';

export default {
  name: 'ReviewOrders',
  components: { AdminLayout, ReviewOrdersTable },
};
</script>
